import React from "react";
import { Grid } from "@material-ui/core";
import { Margin, Title, Text } from "~/components/elements";
import { formatDateView } from "~/utils/tools";

import * as S from "./styles";

export default function AccountMain({
  mobile,
  personalData,
  contactData,
  setEditSenha,
}) {

  const getPhoneNumber = () => {
    if (contactData.TelResidencial) {
      return (
        <>
            <Text level="2" className="title">
              Telefone/Celular
            </Text>
          <Text primary level="2">
            <strong>
            {contactData.TelResidencial}
            </strong>
          </Text>
        </>
      );
    }

    if (contactData.TelComercial) {
      return (
        <>
          <Margin mb={1}>
            <Text level="2" className="title">
              Telefone/Comercial
            </Text>
          </Margin>
          <Text primary level="1">
            {contactData.TelComercial}
          </Text>
        </>
      );
    }

    if (contactData.TelCelular) {
      return (
        <>
            <Text level="2" className="title">
              Telefone/Celular
            </Text>
          <Text primary level="1">
            {contactData.TelCelular}
          </Text>
        </>
      );
    }

    return null;
  };

  return (
    <>

        <Margin mb={mobile ? 4 : 12}>
        <Grid container justifyContent="space-between">
          <S.AccountCard>
            <Margin mb={1}>
              <Title as="3" level="6">
                <strong>Seus dados pessoais</strong>
              </Title>
            </Margin>
            <Margin sm={9}>             
                  <S.CardAbstract>
                    <div>
                        <Text level="2" className="title">
                          Nome
                        </Text>
                      <Text as="strong" level="2">
                        {personalData?.Nome}
                      </Text>
                    </div>
                    <div>
                        <Text level="2" className="title">
                          Data de nascimento
                        </Text>
                      {personalData?.DataNascimento && (
                        <Text as="strong" level="2">
                          {formatDateView(personalData?.DataNascimento)}
                        </Text>
                      )}
                    </div>
                    <div>
                        <Text level="2" className="title">
                          Estado
                        </Text>

                      <Text as="strong" level="2">
                        {personalData?.Estado}
                      </Text>
                    </div>
                  </S.CardAbstract>
            
            </Margin>
          </S.AccountCard>
          
          <S.AccountCard>
              <Title as="3" level="6">
                <strong>Informações de contato</strong>
              </Title>
            <S.CardContact>
                <div>
                  <div>{getPhoneNumber()}</div>
                </div>
              <div>
                <div>
                    <Text level="2" className="title">
                      E-mail
                    </Text>
                  <Text primary level="2">
                    <strong>{contactData.Email}</strong>
                  </Text>
                </div>
              </div>
            </S.CardContact>
          </S.AccountCard>

          <S.TitleHolder>
            <Margin mt={3} mb={3}>
              <Title as="3" level="6">
                Senha cadastrada
              </Title>
            </Margin>
          </S.TitleHolder>

          <S.UpdatePasswordCard>
            <Grid
              container
              justifyContent="space-between"
              alignContent="flex-start"
            >
              <S.UpdatePasswordActions>
                <p>
                    Clique em atualizar senha para você mudar sua senha e atualizar na conta.
                </p>
                <div className="update-password" onClick={() => setEditSenha(true)} style={{color: "#0D5BA8"}}>
                    <b>
                      ATUALIZAR SENHA
                    </b>
                </div>
              </S.UpdatePasswordActions>
            </Grid>
          </S.UpdatePasswordCard>
          <S.ContactUs>
            <Text level="2" primary>
              Se deseja ajustar alguma informação que não conseguiu por aqui,
              por favor,{" "}
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="mailto: promocoeskenvue@holdingclube.com.br"
              >
                Fale Conosco.
              </a>
            </Text>
          </S.ContactUs>
        </Grid>
      </Margin>

    </>
  );
}
